import { EventName } from '@lit/react';
import { BlocksNumericInput } from 'blocks-nextjs/blocks-web-components/components/numeric-input/numeric-input';
import { BlocksNumericInputChangeEvent } from 'blocks-nextjs/blocks-web-components/events';
import React from 'react';
import { createComponent } from '../CustomWrapper/CustomWrapper';

export const CatNumericInput = createComponent({
  react: React,
  tagName: 'cat-numeric-input',
  elementClass: BlocksNumericInput,
  events: {
    onBlNumericInputChange: 'bl-numeric-input-change' as EventName<BlocksNumericInputChangeEvent>
  }
});
